import { render, staticRenderFns } from "./HomeSection.vue?vue&type=template&id=c63c5ecc&scoped=true"
import script from "./HomeSection.vue?vue&type=script&lang=js"
export * from "./HomeSection.vue?vue&type=script&lang=js"
import style0 from "./HomeSection.vue?vue&type=style&index=0&id=c63c5ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63c5ecc",
  null
  
)

export default component.exports